import { Sort } from '@angular/material/sort';
import { ExtendedAttributeFilterInterface } from 'app/library/all-users/interfaces/extended-attribute-filer.interface';
import { Module } from 'app/library/module/models/module.model';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { ICreateCourseOfferingExecutionActionPayload } from '../interfaces/create-course-offering-execution.action.payload.interface';

export class CreateCourseOfferingExecution {
    static readonly type = '[CourseOfferingExecutions] CreateCourseOfferingExecution';

    constructor(public payload: ICreateCourseOfferingExecutionActionPayload) {}
}

export class CreateCourseOfferingExecutionSuccess {
    static readonly type = '[CourseOfferingExecutions] CreateCourseOfferingExecutionSuccess';

    constructor(
        public payload: {
            id: string;
            asyncJobId: string;
            courseOfferingId: string;
        }
    ) {}
}

export class CreateCourseOfferingExecutionFailure {
    static readonly type = '[CourseOfferingExecutions] CreateCourseOfferingExecutionFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class SetCourseOfferingExecutions {
    static readonly type = '[CourseOfferingExecutions] SetCourseOfferingExecutions';

    constructor(public payload: Module[]) {}
}

export class UnsetCourseOfferingExecutions {
    static readonly type = '[CourseOfferingExecutions] UnsetCourseOfferingExecutions';
}

export class FetchCourseOfferingExecutions {
    static readonly type = '[CourseOfferingExecutions] FetchCourseOfferingExecutions';

    constructor(
        public payload: {
            courseOfferingId: string;
            search?: string;
            sortBy?: string;
            sortOrder?: string;
            pageSize?: number;
            pageNumber?: number;
            statusesIds?: string[];
            tags?: string[];
            extendedAttributesFilters?: ExtendedAttributeFilterInterface[];
            columns?: string[];
            context?: string;
        }
    ) {}
}

export class FetchCourseOfferingExecutionsSuccess {
    static readonly type = '[CourseOfferingExecutions] FetchCourseOfferingExecutionsSuccess';

    constructor(public payload: Module[]) {}
}

export class FetchCourseOfferingExecutionsFailure {
    static readonly type = '[CourseOfferingExecutions] FetchCourseOfferingExecutionsFailure';
}

export class FetchCourseOfferingExecutionsSearch {
    static readonly type = '[CourseOfferingExecutions] FetchCourseOfferingExecutionsSearch';

    constructor(public payload: { courseOfferingId: string; programExecutionId: string; tags: number[]; searchTerm: string; users: string[] }) {}
}

export class FetchCourseOfferingExecutionsSearchSuccess {
    static readonly type = '[CourseOfferingExecutions] FetchCourseOfferingExecutionsSearchSuccess';

    constructor(public payload: Module[]) {}
}

export class FetchCourseOfferingExecutionsSearchFailure {
    static readonly type = '[CourseOfferingExecutions] FetchCourseOfferingExecutionsSearchFailure';
}

export class SortCourseOfferingExecutions {
    static readonly type = '[CourseOfferingExecutions] SortCourseOfferingExecutions';

    constructor(
        public payload: {
            sort: Sort;
            storageActiveKey: string;
            storageDirectionKey: string;
        }
    ) {}
}

export class FetchProgramExecutionCourseOfferingExecutions {
    static readonly type = '[CourseOfferingExecutions] FetchProgramExecutionCourseOfferingExecutions';

    constructor(
        public payload?: {
            courseOfferingId: string;
            programExecutionId: string;
            scope: number;
            search?: string;
            pageSize?: number;
            pageNumber?: number;
            statusesIds?: string[];
            context?: string;
        }
    ) {}
}

export class FetchProgramExecutionCourseOfferingExecutionsSuccess {
    static readonly type = '[CourseOfferingExecutions] FetchProgramExecutionCourseOfferingExecutionsSuccess';
}

export class FetchProgramExecutionCourseOfferingExecutionsFailure {
    static readonly type = '[CourseOfferingExecutions] FetchProgramExecutionCourseOfferingExecutionsFailure';
}

export class FetchAllCourseOfferingExecutionsVersions {
    static readonly type = '[CourseOfferingExecutions] FetchAllCourseOfferingExecutionsVersions';

    constructor() {}
}

export class FetchAllCourseOfferingExecutionsVersionsSuccess {
    static readonly type = '[CourseOfferingExecutions] FetchAllCourseOfferingExecutionsVersionsSuccess';

    constructor(public payload: { version: string }[]) {}
}

export class FetchAllCourseOfferingExecutionsVersionsFailure {
    static readonly type = '[CourseOfferingExecutions] FetchAllCourseOfferingExecutionsVersionsFailure';
}

export class SearchCourseOfferingExecutions {
    static readonly type = '[CourseOfferingExecutions] SearchCourseOfferingExecutions';

    constructor(
        public payload: {
            searchItem: string;
            sessionStorageKey: string;
        }
    ) {}
}
